<ng-container *ngTemplateOutlet="skeletonDetails"></ng-container>

<ng-template #skeletonDetails>
  <div class="rounded-4 min-h-475px w-100 px-0">
    <div class="card-body d-flex flex-column justify-content-between p-8">
      <div class="d-flex flex-column">
        <div class="d-flex flex-row align-items-center gap-5 mb-6">
          <div class="skeleton h-25px w-25"></div>
          <div class="skeleton h-20px w-80px"></div>
        </div>
        <div class="d-flex flex-row gap-2 mb-12">
          <div class="skeleton w-20px h-20px"></div>
          <div class="skeleton w-20px h-20px"></div>
          <div class="skeleton w-20px h-20px"></div>
          <div class="skeleton w-20px h-20px"></div>
          <div class="skeleton w-20px h-20px"></div>
        </div>
        <div class="skeleton h-25px w-100 mb-4"></div>
        <div class="skeleton h-25px w-100 mb-4"></div>
        <div class="skeleton h-25px w-100 mb-12"></div>

        <div class="skeleton h-25px w-60px mt-10 mb-4"></div>
        <div class="d-flex flex-row align-items-center gap-2 mb-3">
          <!-- Tutor avatar — now circular in the real content
               (course-description.component.html), so the placeholder shape
               matches instead of resolving into a different one. -->
          <div class="skeleton rounded-circle h-35px w-35px"></div>
          <div class="skeleton h-20px w-25"></div>
        </div>
        <div class="separator my-4"></div>

        <div class="skeleton h-35px w-90px mt-10 mb-4"></div>
        <div class="d-flex flex-row gap-2 mb-3">
          <div class="skeleton h-20px w-100"></div>
        </div>

        <div class="skeleton h-35px w-25 mt-10 mb-4"></div>
        <div class="d-flex flex-row gap-2 mb-6">
          <div class="skeleton h-20px w-150px"></div>
        </div>

        <div class="card p-8">
          <div class="rounded skeleton min-h-400px mh-450px mb-8"></div>
          <ng-container *ngTemplateOutlet="skeletonChapter"></ng-container>
          <ng-container *ngTemplateOutlet="skeletonChapter"></ng-container>
          <ng-container *ngTemplateOutlet="skeletonChapter"></ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #skeletonChapter>
  <div class="d-flex flex-row justify-content-between px-2 py-6">
    <div class="d-flex flex-row gap-3 align-items-center">
      <div class="skeleton rounded-circle h-35px w-35px"></div>
      <div class="d-flex flex-column gap-2">
        <div class="skeleton h-15px w-60px"></div>
        <div class="skeleton h-15px w-100px"></div>
      </div>
    </div>
    <div class="d-flex flex-column gap-2">
      <div class="skeleton h-15px w-80px"></div>
    </div>
  </div>
</ng-template>
